export const BROWSE_CATEGORY_CARDS = [
  { slug: "affordable-housing", label: "Affordable Housing", emoji: "🏠" },
  { slug: "luxury-resale", label: "Luxury Resale", emoji: "💎" },
  { slug: "ultra-luxury-new-launches", label: "Ultra Luxury New Launches", emoji: "🌿" },
  { slug: "plots-registry", label: "Plots (Registry Available)", emoji: "🗺️" },
  { slug: "lowrise-builder-floors", label: "Lowrise Builder Floors (S+4)", emoji: "🏗️" },
  { slug: "commercial", label: "Commercial", emoji: "🏢" }
];

export const CATEGORY_LISTING_PAGES = {
  "commercial": {
    title: "Commercial Projects",
    subtitle: "Open full project list \u2192",
    items: [
      { name: "MVN MALL", detail: "Sector 37D", slug: "mvn-mall-37d", isNewLaunch: true },
      { name: "SATYA THE HIVE", detail: "Sector 102", slug: "satya-the-hive-102" },
      { name: "WTC PLAZA", detail: "Sector 106", slug: "wtc-plaza-106" },
      { name: "CONSCIENT ONE MALL", detail: "Sector 109", slug: "conscient-one-mall-109" },
      { name: "M3M CAPITAL WALK", detail: "Sector 113", slug: "m3m-capital-walk-113" }
    ]
  },
  "affordable-housing": {
    title: "Affordable Housing Projects",
    subtitle: "Dwarka Expressway & New Gurgaon",
    items: [
      { name: "ROF Alante", detail: "Sector 108", slug: "rof-alante-108", isBestDeal: true },
      { name: "Signature Solera 1 & 2", detail: "Sector 107", slug: "signature-solera-107" },
      { name: "Signature Global Grand Iva", detail: "Sector 103", slug: "signature-global-grand-iva-103" },
      { name: "Suncity Avenue", detail: "Sector 102", slug: "suncity-avenue-102" },
      { name: "ROF Alayas", detail: "Sector 102", slug: "rof-alayas-102" },
      { name: "Pivotal Riddhi Siddhi", detail: "Sector 99", slug: "pivotal-riddhi-siddhi-99" },
      { name: "Conscient Habitat", detail: "Sector 99", slug: "conscient-habitat-99" },
      { name: "Pareena Laxmi Apartments", detail: "Sector 99A", slug: "pareena-laxmi-apartments" },
    ],
  },
  "plots-registry": {
    title: "Plot Hi Plot: Registry Plots Available",
    subtitle: "Best for Investment & End Use",
    items: [
      { name: "Experion Westerlies", detail: "Sector 108", slug: "experion-westerlies-108", isBestDeal: true },
      { name: "Noble Township", detail: "Sector 3, Farrukhnagar", slug: "noble-township-3", isNewLaunch: true },
      { name: "BPTP Amastoria", detail: "Sector 102", slug: "bptp-amastoria-102" },
      { name: "QVC & Uppal G-99", detail: "Sector 99", slug: "qvc-uppal-g-99" },
      { name: "Adani Tatva Estate", detail: "Sector 99", slug: "adani-tatva-estate-99" },
      { name: "Skywheels Vienna Green", detail: "Sector 99A", slug: "skywheels-vienna-green-99a" },
      { name: "Spiti Greenwood Estate", detail: "Sector 99A", slug: "spiti-greenwood-estate-99a" },
      { name: "BST Green Bhumi", detail: "Sector 99A", slug: "bst-green-bhumi-99a" },
      { name: "Satya Marino Green", detail: "Sector 99A", slug: "satya-marino-green-99a" },
      { name: "New Palam Vihar Colony", detail: "Q, K, M, N Block", slug: "new-palam-vihar-colony" },
      { name: "Arogya Dham", detail: "Sector 10A, Badsa", slug: "arogya-dham-10a" },
    ],
  },
  "luxury-resale": {
    title: "Resale: Top 10 Luxury Projects",
    subtitle: "Dwarka Expressway, Gurgaon",
    items: [
      { name: "Experion Heartsong", detail: "Sector 108", slug: "experion-heartsong-108", isBestDeal: true },
      { name: "Godrej Meridian", detail: "Sector 106", slug: "godrej-meridian-106", isBestDeal: true },
      { name: "Sobha City", detail: "Sector 109", slug: "sobha-city-vista-108" },
      { name: "Raheja Vedanta", detail: "Sector 108", slug: "raheja-vedanta-108" },
      { name: "M3M Woodshire", detail: "Sector 107", slug: "m3m-woolshire-107" },
      { name: "Indiabulls Centrum Park", detail: "Sector 103", slug: "indiabulls-centrum-park-103" },
      { name: "Ansal Highland Park", detail: "Sector 103", slug: "ansal-highland-park-103" },
      { name: "Ellan The Presidential", detail: "Sector 106", slug: "ellan-the-presidential-106" },
      { name: "Paras Dewas", detail: "Sector 106", slug: "paras-dewas-106" },
      { name: "ATS Triumph", detail: "Sector 104", slug: "ats-triumph-104" },
    ],
  },
  "ultra-luxury-new-launches": {
    title: "Ultra Luxury New Launches",
    subtitle: "Dwarka Expressway, Gurgaon \u2014 Best for Investment",
    items: [
      { name: "Riviera at AIPL Lake City", detail: "Sector 103", slug: "riviera-aipl-103", isNewLaunch: true },
      { name: "Godrej Varikshya", detail: "Sector 103", slug: "godrej-vrikshya-103", isNewLaunch: true },
      { name: "Adani", detail: "Sector 102", slug: "adani-new-launch-102", isNewLaunch: true },
      { name: "Satya Mapple Levante", detail: "Sector 104", slug: "levante-residences-104", isNewLaunch: true },
      { name: "ATS Homekraft Sanctuary", detail: "Sector 105", slug: "ats-homekraft-sanctuary-105", isNewLaunch: true },
      { name: "Pareena Koban", detail: "Sector 99A", slug: "pareena-koban-99a" },
      { name: "Chintal Serenity", detail: "Sector 109", slug: "chintal-serenity-109" },
    ],
  },
  "lowrise-builder-floors": {
    title: "Lowrise Builder Floors (S+4)",
    subtitle: "For Price & More Details",
    forPriceNote:
      "WhatsApp and Call us to get the latest availability and booking details for these lowrise builder floors.",
    items: [
      {
        name: "M2K OLIVE GREEN \u2013 104",
        waDetail: "273 Plots",
        detail:
          "Total Area: 273 Plots. Tower Heights: Stilt +4 (Low Rise). Roof Right: Equally Divide by 4. Config: 3 BHK + 3T \u2013 1400 SQFT (145 Sq. Yards).",
        slug: "m2k-olive-green-104",
        isNewLaunch: true
      },
      {
        name: "MRG CROWN \u2013 106",
        waDetail: "8.5 Acres; 109 Plots",
        detail:
          "Total Area: 8.5 Acres; 109 Plots. Tower Height: Stilt +4 (Low Rise). Basement & Roof Right: Equally Divide by 4. Config: 3 BHK \u2013 1369 / 1503 / 1593 SQFT.",
        slug: "mrg-crown-106"
      },
      { name: "AKRANTE \u2013 106", waDetail: "Tower 106", detail: "New Launch", slug: "akrante-106" },
      { name: "JMS THE NATION \u2013 95", waDetail: "Tower 95", detail: "New Launch", slug: "jms-the-nation-95" },
    ],
  },
};
